exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#lama{position:absolute;height:100%;left:0;right:0;background-color:#f3f3f4}", ""]);

// exports
